export const PUT1Svg = () => (
  <svg
    width='22px'
    height='22px'
    viewBox='0 0 22 22'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>投放-累计投放总量</title>
    <defs>
      <filter id='filter-1'>
        <feColorMatrix
          in='SourceGraphic'
          type='matrix'
          values='0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0'
        ></feColorMatrix>
      </filter>
    </defs>
    <g id='页面-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g
        id='投放-累计投放总量'
        transform='translate(-25.000000, -962.000000)'
        filter='url(#filter-1)'
      >
        <g transform='translate(25.000000, 962.000000)'>
          <rect
            id='矩形'
            fill='#000000'
            fillRule='nonzero'
            opacity='0'
            x='0'
            y='0'
            width='22'
            height='22'
          ></rect>
          <path
            d='M10.99472,4.675 C14.72812,4.675 17.75444,7.70132 17.75444,11.43472 C17.75444,15.16812 14.72812,18.19444 10.99472,18.19444 C7.26132,18.19444 4.235,15.16812 4.235,11.43472 C4.235,7.70132 7.26132,4.675 10.99472,4.675 Z M10.99472,5.71472 C7.83565123,5.71472 5.27472,8.27565123 5.27472,11.43472 C5.27472,14.5937888 7.83565123,17.15472 10.99472,17.15472 C14.15392,17.15472 16.71472,14.59392 16.71472,11.43472 C16.71472,8.27552 14.15392,5.71472 10.99472,5.71472 L10.99472,5.71472 Z M10.78748,10.2212 C11.11044,10.2212 11.37268,10.48388 11.37268,10.80684 L11.37268,13.53616 C11.37268,13.859357 11.110677,14.12136 10.78748,14.12136 C10.464283,14.12136 10.20228,13.859357 10.20228,13.53616 L10.20228,10.80684 C10.2025223,10.4836721 10.4643124,10.2216851 10.78748,10.2212 L10.78748,10.2212 Z M8.11316,11.7814398 C8.2683647,11.7813233 8.417259,11.8428662 8.52708781,11.9525299 C8.63691662,12.0621937 8.69868335,12.2109953 8.6988,12.3662 L8.6988,13.53616 C8.6988,13.859357 8.43679704,14.12136 8.1136,14.12136 C7.79040296,14.12136 7.5284,13.859357 7.5284,13.53616 L7.5284,12.36664 C7.5284,12.04324 7.7902,11.7814398 8.11316,11.7814398 L8.11316,11.7814398 Z M13.46136,8.6614 C13.78476,8.6614 14.047,8.92408 14.047,9.2466 L14.047,13.5366 C14.0528372,13.7494185 13.9426349,13.9486173 13.7592401,14.0567474 C13.5758452,14.1648774 13.3481948,14.1648774 13.1647999,14.0567474 C12.9814051,13.9486173 12.8712028,13.7494185 12.87704,13.5366 L12.87704,9.2466 C12.87704,8.92364 13.13796,8.6614 13.46136,8.6614 L13.46136,8.6614 Z'
            id='形状'
            fill='#71747A'
            fillRule='nonzero'
          ></path>
        </g>
      </g>
    </g>
  </svg>
)

export const PUT2Svg = () => (
  <svg
    width='22px'
    height='22px'
    viewBox='0 0 22 22'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>投放-矿持质押投放</title>
    <defs>
      <filter id='filter-1'>
        <feColorMatrix
          in='SourceGraphic'
          type='matrix'
          values='0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0'
        ></feColorMatrix>
      </filter>
    </defs>
    <g id='页面-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g
        id='投放-矿持质押投放'
        transform='translate(-25.000000, -1027.000000)'
        filter='url(#filter-1)'
      >
        <g transform='translate(25.000000, 1027.000000)'>
          <rect
            id='矩形'
            fill='#000000'
            fillRule='nonzero'
            opacity='0'
            x='0'
            y='0'
            width='22'
            height='22'
          ></rect>
          <path
            d='M15.8109375,3.5359375 L6.1890625,3.5359375 C5.8359375,3.5359375 5.546875,3.8234375 5.546875,4.178125 L5.546875,8.9625 L6.1890625,8.9625 L6.1890625,4.178125 L15.8125,4.178125 L15.8125,8.9625 L16.453125,8.9625 L16.453125,4.178125 C16.453125,3.825 16.165625,3.5359375 15.8109375,3.5359375 Z M15.8109375,15.821875 L6.1890625,15.821875 L6.1890625,10.6890625 L5.546875,10.6890625 L5.546875,15.821875 C5.546875,16.175 5.834375,16.4640625 6.1890625,16.4640625 L15.8125,16.4640625 C16.165625,16.4640625 16.4546875,16.1765625 16.4546875,15.821875 L16.4546875,10.5296875 L15.8125,10.5296875 L15.8125,15.821875 L15.8109375,15.821875 Z'
            id='形状'
            fill='#999999'
            fillRule='nonzero'
          ></path>
          <path
            d='M8.2328125,6.503125 L13.765625,6.503125 L13.765625,7.1453125 L8.2328125,7.1453125 L8.2328125,6.503125 Z M8.2328125,8.5609375 L13.765625,8.5609375 L13.765625,9.203125 L8.2328125,9.203125 L8.2328125,8.5609375 Z M11.3546875,15.034375 L11.3546875,14.653125 L12.775,12.9609375 L12.4078125,12.6515625 L11.3546875,13.90625 L11.3546875,10.834375 L10.7125,10.834375 L10.7125,13.921875 L9.5875,12.6203125 L9.2234375,12.934375 L10.7125,14.6578125 L10.7125,15.034375 L11.3546875,15.034375 Z'
            id='形状'
            fill='#999999'
            fillRule='nonzero'
          ></path>
        </g>
      </g>
    </g>
  </svg>
)

export const PUT3Svg = () => (
  <svg
    width='22px'
    height='22px'
    viewBox='0 0 22 22'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>奖励</title>
    <defs>
      <filter id='filter-1'>
        <feColorMatrix
          in='SourceGraphic'
          type='matrix'
          values='0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0'
        ></feColorMatrix>
      </filter>
    </defs>
    <g id='页面-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='奖励' transform='translate(-25.000000, -1091.000000)' filter='url(#filter-1)'>
        <g transform='translate(25.000000, 1091.000000)'>
          <rect
            id='矩形'
            fill='#000000'
            fillRule='nonzero'
            opacity='0'
            x='0'
            y='0'
            width='22'
            height='22'
          ></rect>
          <path
            d='M19.7714844,13.0847656 L16.6742188,10.1650391 C16.6056641,10.1017578 16.5300781,10.0525391 16.4474609,10.0191406 C16.5792969,9.53574219 16.6460938,9.03476563 16.6460938,8.52675781 C16.6460938,7.01503906 16.0572266,5.59472656 14.9884766,4.52597656 C13.9197266,3.45722656 12.4994141,2.86835938 10.9876953,2.86835938 C9.47597656,2.86835938 8.05566406,3.45722656 6.98691406,4.52597656 C5.91816406,5.59472656 5.32929688,7.01503906 5.32929688,8.52675781 C5.32929688,9.05058594 5.40136719,9.56738281 5.54199219,10.0666016 C5.48574219,10.1 5.43476563,10.1404297 5.3890625,10.1878906 C4.84238281,10.7503906 4.28691406,11.3164063 3.75078125,11.8630859 C3.23046875,12.3921875 2.69257813,12.9388672 2.16171875,13.4855469 C2.01757813,13.6332031 1.97363281,13.8458984 2.04746094,14.0392578 C2.12128906,14.2326172 2.2953125,14.3609375 2.50097656,14.375 C3.14433594,14.4207031 4.09882813,14.5982422 5.00058594,15.1888672 C5.82324219,15.7373047 6.2609375,16.5828125 6.41210938,16.9203125 C6.48242188,17.0802734 6.62832031,17.1927734 6.79882813,17.2244141 C6.83046875,17.2296875 6.86035156,17.2332031 6.89199219,17.2332031 C7.03261719,17.2332031 7.16796875,17.1769531 7.26640625,17.075 L10.1492188,14.1236328 C10.4269531,14.1640625 10.7064453,14.1851563 10.9876953,14.1851563 C11.3041016,14.1851563 11.6222656,14.1587891 11.9333984,14.1060547 C12.4220703,14.5701172 12.9195313,15.0341797 13.4011719,15.4841797 C13.9742188,16.0185547 14.5666016,16.5705078 15.1414063,17.1207031 C15.2398438,17.215625 15.3699219,17.2666016 15.5035156,17.2666016 C15.5439453,17.2666016 15.5861328,17.2613281 15.6265625,17.2525391 C15.8005859,17.2103516 15.9412109,17.0837891 15.9992188,16.9150391 C16.1767578,16.4052734 16.5652344,15.6775391 17.4177734,15.0992188 C18.0558594,14.6738281 18.8539063,14.4505859 19.4111328,14.3380859 C19.6800781,14.2835938 19.8945313,14.0849609 19.9701172,13.8212891 C20.0474609,13.5558594 19.9701172,13.2746094 19.7714844,13.0847656 L19.7714844,13.0847656 Z M6.94296875,16.3982422 C6.6828125,15.8867188 6.19589844,15.1378906 5.3890625,14.6017578 L5.38730469,14.6 C4.52246094,14.0339844 3.62070313,13.8001953 2.92285156,13.7105469 C3.36757813,13.2535156 3.81582031,12.7982422 4.25,12.3552734 C4.75625,11.8402344 5.27832031,11.309375 5.79335938,10.7767578 C6.45429688,12.3007813 7.76210938,13.4609375 9.34238281,13.9408203 L6.94296875,16.3982422 Z M10.0894531,13.3994141 C8.36328125,13.0830078 6.92011719,11.8595703 6.32421875,10.2037109 L5.99375,10.3232422 L6.32421875,10.2037109 C6.13085938,9.66582031 6.03242188,9.1015625 6.03242188,8.525 C6.03242188,5.79335938 8.25605469,3.56972656 10.9876953,3.56972656 C13.7193359,3.56972656 15.9429688,5.79335938 15.9429688,8.525 C15.9429688,9.12089844 15.8375,9.70273438 15.6318359,10.2564453 C15.0376953,11.8472656 13.6367188,13.0460938 11.9755859,13.3818359 C11.3603516,13.5083984 10.7099609,13.5136719 10.0894531,13.3994141 Z M19.296875,13.6261719 C19.2916016,13.64375 19.2810547,13.6455078 19.2740234,13.6472656 C18.6535156,13.7720703 17.7605469,14.0251953 17.0275391,14.5138672 L17.0257813,14.515625 C16.146875,15.1115234 15.6810547,15.8462891 15.4349609,16.428125 C14.9181641,15.9359375 14.3925781,15.4455078 13.8810547,14.9691406 C13.5066406,14.6210938 13.1251953,14.2642578 12.7455078,13.9056641 C13.4503906,13.6753906 14.1078125,13.30625 14.6738281,12.8193359 C15.3453125,12.2410156 15.8744141,11.5115234 16.2136719,10.6976563 L19.2880859,13.5962891 C19.2933594,13.6015625 19.3021484,13.6085938 19.296875,13.6261719 L19.296875,13.6261719 Z'
            id='形状'
            fill='#727171'
            fillRule='nonzero'
          ></path>
          <path
            d='M14.4751953,6.5703125 C14.4751953,6.47539063 14.4400391,6.38398438 14.3767578,6.32246094 C14.3152344,6.2609375 14.2238281,6.22402344 14.1289062,6.22402344 C14.0339844,6.22402344 13.9425781,6.25917969 13.8810547,6.32246094 L13.8792969,6.32421875 L10.6853516,9.69394531 L9.09277344,8.18574219 C8.96269531,8.05742188 8.72714844,8.05917969 8.59707031,8.1875 C8.46699219,8.31757813 8.46699219,8.55488281 8.59707031,8.68496094 L10.3707031,10.3654297 C10.4269531,10.4199219 10.5060547,10.4550781 10.5904297,10.4603516 C10.6378906,10.4814453 10.6888672,10.4919922 10.7416016,10.4919922 C10.8347656,10.4919922 10.9261719,10.4585938 10.9912109,10.3935547 L14.3785156,6.81640625 C14.4400391,6.75488281 14.4751953,6.66523438 14.4751953,6.5703125 Z'
            id='路径'
            fill='#727171'
            fillRule='nonzero'
          ></path>
        </g>
      </g>
    </g>
  </svg>
)

export const PUT4Svg = () => (
  <svg
    width='22px'
    height='22px'
    viewBox='0 0 22 22'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>社区</title>
    <defs>
      <filter id='filter-1'>
        <feColorMatrix
          in='SourceGraphic'
          type='matrix'
          values='0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0'
        ></feColorMatrix>
      </filter>
    </defs>
    <g id='页面-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='社区' transform='translate(-25.000000, -1155.000000)' filter='url(#filter-1)'>
        <g transform='translate(25.000000, 1155.000000)'>
          <rect
            id='矩形'
            fill='#000000'
            fillRule='nonzero'
            opacity='0'
            x='0'
            y='0'
            width='22'
            height='22'
          ></rect>
          <path
            d='M10.9439545,17.2427273 C7.46913637,17.2427273 4.64272727,14.4159091 4.64272727,10.9410909 C4.64272727,7.46627271 7.46954546,4.63945454 10.9439545,4.63945454 C14.4187727,4.63945454 17.2455909,7.46627271 17.2455909,10.9410909 C17.2455909,14.4159091 14.4187727,17.2427273 10.9439545,17.2427273 Z M10.9439545,5.45763637 C7.92036363,5.45763637 5.4609091,7.9175 5.4609091,10.9410909 C5.4609091,13.9646818 7.92077273,16.4245455 10.9439545,16.4245455 C13.9679545,16.4245455 16.4274091,13.9646818 16.4274091,10.9410909 C16.4274091,7.91749998 13.9679545,5.45763637 10.9439545,5.45763637 Z M4.11377273,17.3638182 C3.2694091,17.3638182 2.64513637,17.1400454 2.3505909,16.6303182 C1.58845454,15.3097727 3.67972727,13.2221818 4.99372727,12.0951364 L5.52636363,12.7161364 C3.4629091,14.4858636 2.8005909,15.7740909 3.05913637,16.2212273 C3.52795454,17.0345 7.20404546,16.4245454 12.1241818,13.5846364 C17.0439091,10.7439091 19.4100909,7.86554546 18.9404545,7.05227273 C18.7064545,6.64563637 17.4881818,6.54254546 15.2954545,7.2285909 L15.0508182,6.44763637 C16.7837273,5.9055909 18.9883182,5.49936363 19.649,6.64318183 C20.6557727,8.38672729 16.8311818,11.8112273 12.5332727,14.2931818 C9.49168183,16.0494091 6.15881819,17.3638182 4.11377273,17.3638182 L4.11377273,17.3638182 Z'
            id='形状'
            fill='#000000'
            fillRule='nonzero'
          ></path>
        </g>
      </g>
    </g>
  </svg>
)

export const QUIconSvg = () => (
  <svg
    width='11px'
    height='12px'
    viewBox='0 0 11 12'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>区块</title>
    <defs>
      <filter id='filter-1'>
        <feColorMatrix
          in='SourceGraphic'
          type='matrix'
          values='0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0'
        ></feColorMatrix>
      </filter>
    </defs>
    <g id='页面-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='首页-正式' transform='translate(-37.000000, -476.000000)'>
        <g id='编组-24' transform='translate(11.000000, 378.000000)'>
          <g id='区块' transform='translate(23.000000, 97.000000)' filter='url(#filter-1)'>
            <g transform='translate(3.000000, 1.000000)'>
              <rect
                id='矩形'
                fill='#000000'
                fillRule='nonzero'
                opacity='0'
                x='0'
                y='0'
                width='11'
                height='11'
              ></rect>
              <path
                d='M5.4885,1 L9.97700001,3.59150001 L9.97700001,8.7745 L5.4885,11.366 L1,8.7745 L1,3.59150001 L5.4885,1 Z M1.74975,4.58225001 L1.74975,8.34125001 L5.1135,10.28325 L5.1135,6.5245 L1.74975,4.582 L1.74975,4.58225001 Z M9.22700001,4.58225001 L5.8635,6.52475001 L5.8635,10.283 L9.22700001,8.341 L9.22700001,4.5825 L9.22700001,4.58225001 Z M5.4885,1.86625 L2.01650001,3.87050001 L5.4885,5.875 L8.96025,3.87050001 L5.4885,1.866 L5.4885,1.86625 Z'
                id='形状'
                fill='#1677FF'
                fillRule='nonzero'
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const SLIconSvg = () => (
  <svg
    width='13px'
    height='11px'
    viewBox='0 0 13 11'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>高性能多元算力</title>
    <defs>
      <filter id='filter-1'>
        <feColorMatrix
          in='SourceGraphic'
          type='matrix'
          values='0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0'
        ></feColorMatrix>
      </filter>
    </defs>
    <g id='页面-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='首页-正式' transform='translate(-181.000000, -477.000000)'>
        <g id='编组-24' transform='translate(11.000000, 378.000000)'>
          <g
            id='高性能多元算力'
            transform='translate(23.000000, 97.000000)'
            filter='url(#filter-1)'
          >
            <g transform='translate(148.000000, 2.000000)'>
              <rect
                id='矩形'
                fill='#000000'
                fillRule='nonzero'
                opacity='0'
                x='0'
                y='0'
                width='11'
                height='11'
              ></rect>
              <path
                d='M1.72929166,1.17447916 L9.28285416,1.17447916 L10.5389167,5.29947916 L0.4613125,5.29947916 L1.72929166,1.17447916 Z M1.89864584,1.40364584 L0.771375,5.0703125 L10.2293125,5.0703125 L9.1128125,1.40364584 L1.89864584,1.40364584 Z'
                id='形状'
                stroke='#979797'
                strokeWidth='0.3'
                fill='#252B3A'
                fillRule='nonzero'
              ></path>
              <polygon
                id='路径'
                stroke='#979797'
                strokeWidth='0.3'
                fill='#252B3A'
                fillRule='nonzero'
                points='0.546333337 7.1328125 1.57139584 5.29947916 1.375 5.18145834 0.141395837 7.36197916 10.8586042 7.36197916 9.82139584 5.18145834 9.625 5.29947916 10.4538958 7.1328125'
              ></polygon>
              <path
                d='M10.4538958,9.1953125 L0.546333337,9.1953125 L1.48958334,7.36541666 L1.2931875,7.24739584 L0.141395837,9.42447916 L10.8586042,9.42447916 L9.73958334,7.24739584 L9.5431875,7.36541666 L10.4538958,9.1953125 Z M2.97916666,3.46614584 L4.8125,3.46614584 L4.8125,3.23697916 L2.97916666,3.23697916 L2.97916666,3.46614584 Z'
                id='形状'
                stroke='#979797'
                strokeWidth='0.3'
                fill='#252B3A'
                fillRule='nonzero'
              ></path>
              <polygon
                id='路径'
                stroke='#979797'
                strokeWidth='0.3'
                fill='#F66F6A'
                fillRule='nonzero'
                points='5.95833334 3.46614584 8.02083334 3.46614584 8.02083334 3.23697916 5.95833334 3.23697916'
              ></polygon>
              <polygon
                id='路径'
                stroke='#979797'
                strokeWidth='0.3'
                fill='#F66F6A'
                fillRule='nonzero'
                points='7.10416666 4.3828125 7.10416666 2.3203125 6.875 2.3203125 6.875 4.3828125'
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const RANIconSvg = () => (
  <svg
    width='9px'
    height='10px'
    viewBox='0 0 9 10'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>形状结合</title>
    <g id='页面-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='首页-正式' transform='translate(-38.000000, -553.000000)' fill='#FFFFFF'>
        <path
          d='M39,553 L39,563 L38,563 L38,553 L39,553 Z M40.6081108,553.391889 L46.3918892,557.891889 L40.6081108,562.391889 L40.6081108,553.391889 Z'
          id='形状结合'
        ></path>
      </g>
    </g>
  </svg>
)

export const CIRIconSvg = () => (
  <svg
    width='7px'
    height='13px'
    viewBox='0 0 7 13'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>编组 6备份</title>
    <g id='页面-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='首页-正式' transform='translate(-20.000000, -677.000000)' fill='#09F8D3'>
        <g id='编组-14' transform='translate(20.000000, 677.000000)'>
          <rect id='矩形' opacity='0.100000001' x='0' y='0' width='7' height='13'></rect>
          <rect id='矩形' x='2.1' y='8.27272727' width='2.8' height='2.16666667'></rect>
          <rect id='矩形备份-28' x='2.1' y='1.77272727' width='2.8' height='2.16666667'></rect>
          <rect id='矩形备份-29' x='2.1' y='5.02272727' width='2.8' height='2.16666667'></rect>
        </g>
      </g>
    </g>
  </svg>
)

export const SSIconSvg = () => (
  <svg
    width='6px'
    height='10px'
    viewBox='0 0 6 10'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>上升</title>
    <defs>
      <filter id='filter-1'>
        <feColorMatrix
          in='SourceGraphic'
          type='matrix'
          values='0 0 0 0 0.035294 0 0 0 0 0.972549 0 0 0 0 0.827451 0 0 0 1.000000 0'
        ></feColorMatrix>
      </filter>
    </defs>
    <g id='页面-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='首页-正式' transform='translate(-219.000000, -679.000000)'>
        <g id='编组-20' transform='translate(219.000000, 674.000000)'>
          <g id='上升' transform='translate(0.000000, 5.000000)'>
            <g filter='url(#filter-1)' id='编组-18'>
              <g id='编组' fill='#FFFFFF'>
                <polygon id='矩形备份-11' points='3.13124715 0 6 4 0 4'></polygon>
              </g>
            </g>
            <rect id='矩形' fill='#09F8D3' x='2' y='3' width='2' height='2'></rect>
            <rect
              id='矩形备份-2'
              fill='#09F8D3'
              opacity='0.5'
              x='2'
              y='5'
              width='2'
              height='1'
            ></rect>
            <rect
              id='矩形备份-8'
              fill='#09F8D3'
              opacity='0.400000006'
              x='2'
              y='6.78571429'
              width='2'
              height='1'
            ></rect>
            <rect
              id='矩形备份-14'
              fill='#09F8D3'
              opacity='0.300000012'
              x='2'
              y='7.78571429'
              width='2'
              height='1'
            ></rect>
            <rect
              id='矩形备份-17'
              fill='#09F8D3'
              opacity='0.200000003'
              x='2'
              y='8.78571429'
              width='2'
              height='1'
            ></rect>
            <rect
              id='矩形备份-18'
              fill='#09F8D3'
              opacity='0.100000001'
              x='2'
              y='8.78571429'
              width='2'
              height='1'
            ></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
